import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, onSnapshot, query } from "firebase/firestore";

function formatCurrency(n) {
  return n.toLocaleString("tr-TR", { style: "currency", currency: "TRY" });
}

function formatMonthName(date) {
  const months = [
    "OCAK","ŞUBAT","MART","NİSAN","MAYIS","HAZİRAN",
    "TEMMUZ","AĞUSTOS","EYLÜL","EKİM","KASIM","ARALIK"
  ];
  return months[date.getMonth()];
}

function formatDate(ts) {
  return ts.toDate().toLocaleDateString("tr-TR");
}

export default function PatronDashboard() {
  const navigate = useNavigate();

  const [gelirler, setGelirler] = useState([]);
  const [giderler, setGiderler] = useState([]);
  const [loading, setLoading] = useState(true);

  const [now, setNow] = useState(new Date());
  const [alertOpen, setAlertOpen] = useState(false);        // Tahsilat Zili
  const [giderAlertOpen, setGiderAlertOpen] = useState(false); // Ödeme Zili

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const buAyAdi = formatMonthName(now);

  useEffect(() => {
    const taksitQuery = query(collection(db, "taksitler"));
    const unsub1 = onSnapshot(taksitQuery, (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setGelirler(arr);
      setLoading(false);
    });

    const unsub2 = onSnapshot(collection(db, "odemeler"), (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setGiderler(arr);
    });

    return () => {
      unsub1();
      unsub2();
    };
  }, []);

  if (loading) return <p>Patron Paneli Yükleniyor...</p>;

  // --- ZİL BİLDİRİMLERİ (BUGÜN) ---
  const bugunkuOdemeler = gelirler.filter((t) => {
    const d = t.odemeGunu.toDate();
    return (
      t.durum !== "Ödendi" &&
      d.getDate() === now.getDate() &&
      d.getMonth() === now.getMonth() &&
      d.getFullYear() === now.getFullYear()
    );
  });

  const bugunkuGiderler = giderler.filter((g) => {
    if (!g.odemeTarihi) return false;
    const d = g.odemeTarihi.toDate();
    return (
      g.durum !== "Ödendi" &&
      d.getDate() === now.getDate() &&
      d.getMonth() === now.getMonth() &&
      d.getFullYear() === now.getFullYear()
    );
  });

  // --- KART HESAPLAMALARI (SADECE BU AY) ---
  const buAyGelenPara = gelirler
    .filter((t) => {
      const d = t.odemeGunu.toDate();
      return (
        t.durum === "Ödendi" &&
        d.getMonth() === now.getMonth() &&
        d.getFullYear() === now.getFullYear()
      );
    })
    .reduce((a, b) => a + b.miktar, 0);

  const buAyGelecekPara = gelirler
    .filter((t) => {
      const d = t.odemeGunu.toDate();
      return (
        t.durum !== "Ödendi" &&
        d.getMonth() === now.getMonth() &&
        d.getFullYear() === now.getFullYear()
      );
    })
    .reduce((a, b) => a + b.miktar, 0);

  const buAyOdenenGider = giderler
    .filter((g) => {
        if (!g.odemeTarihi) return false;
        const d = g.odemeTarihi.toDate();
        return (
            g.durum === "Ödendi" &&
            d.getMonth() === now.getMonth() &&
            d.getFullYear() === now.getFullYear()
        );
    })
    .reduce((a, b) => a + b.miktar, 0);

  const buAyOdenecekGider = giderler
    .filter((g) => {
        if (!g.odemeTarihi) return false;
        const d = g.odemeTarihi.toDate();
        return (
            g.durum !== "Ödendi" &&
            d.getMonth() === now.getMonth() &&
            d.getFullYear() === now.getFullYear()
        );
    })
    .reduce((a, b) => a + b.miktar, 0);

  // --- TABLO LİSTELERİ (BU AY) ---
  const buAyGelirListesi = gelirler
    .filter((t) => {
        const d = t.odemeGunu.toDate();
        return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
    })
    .sort((a, b) => a.odemeGunu.toDate() - b.odemeGunu.toDate());

  const buAyGiderListesi = giderler
    .filter((g) => {
        if (!g.odemeTarihi) return false;
        const d = g.odemeTarihi.toDate();
        return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
    })
    .sort((a, b) => a.odemeTarihi.toDate() - b.odemeTarihi.toDate());


  return (
    <div className="admin-page">

      {/* HEADER */}
      <div className="admin-header">
        <h1 
            className="brand-logo admin-brand-header"
            onClick={() => navigate('/patron/dashboard')}
            style={{ cursor: 'pointer' }}
            title="Panele Dön"
        >
          <img src="/logo.png" width="50" alt="" />
          ARAS ASAF İNŞAAT – PATRON PANELİ
        </h1>

        <div className="date-time-info">
          {now.toLocaleDateString("tr-TR")} | {now.toLocaleTimeString("tr-TR")}
        </div>

        {/* ZİL GRUBU */}
        <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
            
            {/* 🔔 ZİL 1: TAHSİLATLAR */}
            <div style={{ position: "relative" }} onMouseEnter={() => setAlertOpen(true)} onMouseLeave={() => setAlertOpen(false)}>
              <div className="notification-wrapper" title="Bugün Gelecekler">
                <span className="notification-icon">🔔</span>
                {bugunkuOdemeler.length > 0 && (
                  <span className="notification-badge">{bugunkuOdemeler.length}</span>
                )}
              </div>
              {alertOpen && (
                <div className="alert-box">
                  <h4 style={{backgroundColor:'#28a745'}}>Bugün Gelecek Paralar</h4>
                  {bugunkuOdemeler.length === 0 && <p style={{ padding: "15px", color: "#666", textAlign: "center", fontSize: "0.9rem" }}>Bugün tahsilat yok.</p>}
                  {bugunkuOdemeler.length > 0 && (
                    <ul>
                      {bugunkuOdemeler.map((t) => (
                        <li key={t.id}>
                          <strong>{t.cariAd}</strong> <br/> 
                          <span style={{color:'#28a745', fontWeight:'bold'}}>+{formatCurrency(t.miktar)}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
            </div>

            {/* 💸 ZİL 2: ÖDEMELER */}
            <div style={{ position: "relative" }} onMouseEnter={() => setGiderAlertOpen(true)} onMouseLeave={() => setGiderAlertOpen(false)}>
              <div className="notification-wrapper" title="Bugün Ödenecekler" style={{ borderColor: '#dc3545' }}>
                <span className="notification-icon">💸</span>
                {bugunkuGiderler.length > 0 && (
                  <span className="notification-badge" style={{backgroundColor:'#dc3545'}}>{bugunkuGiderler.length}</span>
                )}
              </div>
              {giderAlertOpen && (
                <div className="alert-box">
                  <h4 style={{backgroundColor:'#dc3545'}}>Bugün Yapılacak Ödemeler</h4>
                  {bugunkuGiderler.length === 0 && <p style={{ padding: "15px", color: "#666", textAlign: "center", fontSize: "0.9rem" }}>Bugün ödeme yok.</p>}
                  {bugunkuGiderler.length > 0 && (
                    <ul>
                      {bugunkuGiderler.map((g) => (
                        <li key={g.id}>
                          <strong>{g.firmaSahis}</strong> <br/> 
                          <span style={{color:'#dc3545', fontWeight:'bold'}}>-{formatCurrency(g.miktar)}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
            </div>

            <Link to="/" className="admin-button-secondary small">Çıkış Yap</Link>
        </div>
      </div>

      {/* --- MENÜ BUTONLARI --- */}
      <div className="patron-menu-buttons">
        <Link to="/patron/raporlama" className="admin-button-secondary small">📊 Raporlama</Link>
        <Link to="/patron/musteriler" className="admin-button-secondary small">👥 Müşteriler</Link>
      </div>

      {/* --- ANA KARTLAR (AYLIK DURUM) --- */}
      <div className="summary-card-grid">

        {/* KART 1: BU AY ÖDENEN GİDER */}
        <div className="summary-card" style={{borderTopColor: '#fd7e14'}}>
          <h3 className="card-title">{buAyAdi} AYI ÖDENEN GİDER</h3>
          <p className="card-amount" style={{color: '#fd7e14'}}>{formatCurrency(buAyOdenenGider)}</p>
        </div>

        {/* KART 2: BU AY GELEN PARA */}
        <div className="summary-card gelir">
          <h3 className="card-title">{buAyAdi} AYI GELEN PARA</h3>
          <p className="card-amount">{formatCurrency(buAyGelenPara)}</p>
        </div>

        {/* KART 3: BU AY ÖDENECEK PARA */}
        <div className="summary-card gider">
          <h3 className="card-title">{buAyAdi} AYI ÖDENECEK PARA</h3>
          <p className="card-amount">{formatCurrency(buAyOdenecekGider)}</p>
        </div>

        {/* KART 4: BU AY GELECEK PARA */}
        <div
          className="summary-card beklenen"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/patron/gelecek-aylar")} 
        >
          <h3 className="card-title">{buAyAdi} AYI GELECEK PARA</h3>
          <p className="card-amount">{formatCurrency(buAyGelecekPara)}</p>
        </div>
      </div>

      {/* --- YENİ: İKİ BÖLÜMLÜ FİNANSAL GÜNDEM --- */}
      
      {/* TABLO 1: TAHSİLATLAR (GELİR) */}
      <div className="admin-table-container">
        <h2 style={{ color: "#28a745" }}>{buAyAdi} AYI TAHSİLAT GÜNDEMİ (GELEN PARALAR)</h2>
        <table className="admin-table">
          <thead>
            <tr>
              <th>Müşteri</th>
              <th>Tarih</th>
              <th>Miktar</th>
              <th>Durum</th>
            </tr>
          </thead>
          <tbody>
            {buAyGelirListesi.map((t) => (
                <tr key={t.id}>
                  <td>{t.cariAd}</td>
                  <td>{formatDate(t.odemeGunu)}</td>
                  <td>{formatCurrency(t.miktar)}</td>
                  <td>
                    <span className={t.durum === 'Ödendi' ? 'status-paid' : (t.odemeGunu.toDate() < new Date() ? 'status-overdue' : 'status-pending')}>
                        {t.durum === 'Bekliyor' && t.odemeGunu.toDate() < new Date() ? 'VADESİ GEÇTİ' : t.durum.toUpperCase()}
                    </span>
                  </td>
                </tr>
              ))}
            {buAyGelirListesi.length === 0 && <tr><td colSpan="4" style={{ textAlign: 'center' }}>Bu aya ait tahsilat kaydı yok.</td></tr>}
          </tbody>
        </table>
      </div>

      {/* TABLO 2: ÖDEMELER (GİDER) */}
      <div className="admin-table-container" style={{marginTop: '30px'}}>
        <h2 style={{ color: "#dc3545" }}>{buAyAdi} AYI ÖDEME GÜNDEMİ (GİDEN PARALAR)</h2>
        <table className="admin-table">
          <thead>
            <tr>
              <th>Firma / Şahıs</th>
              <th>Tarih</th>
              <th>Miktar</th>
              <th>Durum</th>
            </tr>
          </thead>
          <tbody>
            {buAyGiderListesi.map((g) => (
                <tr key={g.id}>
                  <td>{g.firmaSahis}</td>
                  <td>{formatDate(g.odemeTarihi)}</td>
                  <td>{formatCurrency(g.miktar)}</td>
                  <td>
                    <span className={g.durum === 'Ödendi' ? 'status-paid' : (g.odemeTarihi.toDate() < new Date() ? 'status-overdue' : 'status-pending')}>
                        {g.durum === 'Bekliyor' && g.odemeTarihi.toDate() < new Date() ? 'VADESİ GEÇTİ' : g.durum.toUpperCase()}
                    </span>
                  </td>
                </tr>
              ))}
            {buAyGiderListesi.length === 0 && <tr><td colSpan="4" style={{ textAlign: 'center' }}>Bu aya ait ödeme kaydı yok.</td></tr>}
          </tbody>
        </table>
      </div>

    </div>
  );
}